import { Concept } from './components/Concept'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { LetterOfIntent } from './components/LetterOfIntent'
import { ProductShowcase } from './components/ProductShowcase'
import { ScrollProgress } from './components/ScrollProgress'
import { StorePresence } from './components/StorePresence'
import { WhyKcc } from './components/WhyKcc'

export default function App() {
  return (
    <>
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <LetterOfIntent />
        <Concept />
        <ProductShowcase />
        <StorePresence />
        <WhyKcc />
      </main>
      <Footer />
    </>
  )
}
